<script lang="tsx">
import { defineComponent, reactive, toRefs } from 'vue'
import { Node } from '@antv/x6'
import businessImg from '@/assets/images/flow/business.png'
import peerImg from '@/assets/images/flow/peer.png'
import childImg from '@/assets/images/flow/child.png'
import { businessStatusOptions, NodeType } from '@/enums/flow'

const props = {
  node: {
    type: Node
  }
}

export default defineComponent({
  name: 'FlowBusinessResult',
  props,
  setup(props) {
    const { node } = props
    let flowData = reactive({ current: node.getData() })
    node.on('change:data', e => {
      flowData.current = e.current
    })

    const { current } = toRefs(flowData)

    return () => (
      <div>
        <div class="flow_wrap">
          <div class="flow_chat">
            <div class="tw-flex tw-items-center tw-w-full tw-justify-between">
              <div class="tw-flex tw-items-center">
                <div class="flow_icon">
                  <img
                    src={
                      current.value.icon === NodeType.BUSINESS
                        ? businessImg
                        : current.value.icon === NodeType.PEER
                          ? peerImg
                          : childImg
                    }
                  ></img>
                </div>
                <span class="node-name">{current.value?.name || '请在属性配置'}</span>
              </div>
              {current.value?.hasApprovalProcess ? (
                <span
                  class="icon iconfont icon-shenpi tw-flex-shrink-0 tw-cursor-pointer"
                  style="color: #FCAC33"
                ></span>
              ) : (
                ''
              )}
            </div>
            <div class="deal-info">
              {current.value.state === 'DONE' ? (
                <div>
                  <div class="tw-mb-2">{current.value.operators.join(',')}</div>
                  <div class="tw-align-top">{current.value.dealTime}</div>
                </div>
              ) : (
                <div></div>
              )}
              <div
                class="flow_status !tw-mr-0"
                style={`background-color: ${
                  businessStatusOptions[current.value.state]?.bgColor || ''
                }; color: ${businessStatusOptions[current.value.state]?.color || ''};`}
              >
                <span>{businessStatusOptions[current.value.state]?.name || ''}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
})
</script>
<style scoped lang="scss">
.flow_wrap {
  cursor: move;
  display: flex;
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 2px 5px 0 #00000014;
  border: 1px solid transparent;
  box-sizing: border-box;
  .flow_chat {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 8px;
    position: relative;
    flex-wrap: wrap;
    .flow_icon {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 8px;
      img {
        width: 20px;
        height: 20px;
      }
    }
    .deal-info {
      width: 100%;
      flex-shrink: 0;
      font-size: 10px;
      color: #aaa;
      padding: 10px 0 5px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .node-name {
    color: #333333;
    font-size: 14px;
    word-break: break-all;
  }
  .flow_status {
    font-size: 12px;
    line-height: 20px;
    padding: 2px 6px;
    border-radius: 2px;
    flex-shrink: 0;
  }
}
</style>
